import DefaultImg from "../../../../assets/img/default-image.svg";
import {
    TUserDetails,
    TVacancy
} from "../../../../store/vacancy/types";
import { capitalizeName, extractSuburbFromAddress } from "../../../../utils/stringUtils";
import CustomButton from "../../../UI/Buttons/CustomButton";
import PersonID from "../../../UI/Icons/PersonID";
import RoundedTick from "../../../UI/Icons/RoundedTick";
import StarRating from "../../../UI/StarRating";
import ErrorMessage from "../../../UI/Tooltips/ErrorMessage";

const AppliedCandidate = ({
  isAdmin,
  selectedVacancyDetails,
  appliedCandidate,
  openApplicantButton,
  setOpenApplicantButton,
  onSelect,
  handleViewProfile,
  setViewSelectedCandidateProfile,
  openApplicantRef,
  viewSelectedCandidateProfile,
}: {
  isAdmin: boolean;
  selectedVacancyDetails: TVacancy | null;
  appliedCandidate: TUserDetails;
  handleViewProfile: (
    id: string | null,
    centre_id: string | null
  ) => Promise<void>;
  setViewSelectedCandidateProfile: React.Dispatch<
    React.SetStateAction<number | null>
  >;
  openApplicantButton: boolean;
  setOpenApplicantButton: React.Dispatch<React.SetStateAction<boolean>>;
  viewSelectedCandidateProfile: number | null;
  openApplicantRef: React.RefObject<HTMLDivElement | null>;
  onSelect: (vacancyId: number, appliedCandidateId: number) => void;
}) => {
  const {
    id,
    vacancy_current_status,
    selected_candidate_id,
    centre_id,
    centre
  } = selectedVacancyDetails || {};

  const isDocumentExpired = appliedCandidate.is_documents_expired;

  return (
    <div className="two-col">
      <div className={`border border-grey-light p-15px radius-8px d-flex flex-column flex-lg-row gap-20 ${isDocumentExpired ? "disabled-lineitem" : ""}`}>
        <div
          className="w-100px h-100px radius-50px cursor-pointer hover-overlay-text"
          onClick={() =>
            handleViewProfile(appliedCandidate?.uuid, String(centre_id))
          }
        >
          <img
            alt="Candidate"
            width="100px"
            height="100px"
            className="img-responsive rounded-circle object-fit-cover"
            src={appliedCandidate.photo ?? DefaultImg}
          />
          <div className="overlay-text">
            <div className="d-flex flex-column align-items-center justify-content-center h-100 fs-16 fw-700 text-white">
              <PersonID size={30} color="#FFFFFF" />
              <div>View</div>
              <div>Profile</div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column gap-10 w-100">
          <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between gap-10">
            <div
              className="fs-16 fw-700 text-black cursor-pointer hover-underline"
              onClick={() =>
                handleViewProfile(appliedCandidate?.uuid, String(centre_id))
              }
            >
              {capitalizeName(appliedCandidate?.first_name ?? "")} {capitalizeName(appliedCandidate?.last_name ?? "")}
            </div>

            {vacancy_current_status !== "expired" && (
              <CustomButton
                variant={"primary"}
                type="button"
                className="btn-theme bg-teal text-black max-h-30px"
                onClick={() => onSelect(id ?? 0, appliedCandidate.id ?? 0)}
              >
                <RoundedTick color={"#000000"} />
                Select
              </CustomButton>
            )}
          </div>
          <div className="d-flex gap-10 align-items-center">
            <StarRating
              rating={
                isAdmin
                  ? appliedCandidate?.rating?.average_rating || 0
                  : appliedCandidate?.rating?.latest_rating ||
                    appliedCandidate?.rating?.average_rating ||
                    0
              }
              color={
                isAdmin || !appliedCandidate?.rating?.latest_rating
                  ? "#aaaaaa"
                  : "#51C2B9"
              }
            />
            {!isAdmin &&
              !appliedCandidate?.rating?.latest_rating &&
              appliedCandidate?.rating?.average_rating && (
                <div className="fs-10 fw-400 text-grey-dark">
                  Average Rating
                </div>
              )}
            {Boolean(appliedCandidate.is_preferred) && (
              <div className="border border-teal-dark bg-teal-pale py-4px px-8px radius-8px fs-13 text-teal-dark text-nowrap me-auto cursor-pointer">
                <div className="fs-13 fw-400 text-teal-dark">Preferred</div>
              </div>
            )}
          </div>
          {isDocumentExpired ? <ErrorMessage className="align-items-center gap-3 lh-1" message="Documents Expired" /> : ""}
          <div className="d-flex flex-column fs-13 fw-400 text-black">
            <div>
              {appliedCandidate?.designation?.length > 0
                ? appliedCandidate?.designation
                : "-"}
            </div>
            <div>Lives in {extractSuburbFromAddress(appliedCandidate?.address ?? "")}</div>
          </div>
          <div className="d-flex gap-30">
            <div className="d-flex flex-column gap-5">
              <div className="fs-13 fw-400 text-black">
                {appliedCandidate.past_jobs_count_without_centre ?? 0}
              </div>
              <div className="fs-10 fw-400 text-grey-medium">
                Past Jobs at
                <br />
                Any Centre
              </div>
            </div>
            <div className="d-flex flex-column gap-5">
              <div className="fs-13 fw-400 text-black">
                {appliedCandidate.past_jobs_count ?? 0}
              </div>
              <div className="fs-10 fw-400 text-grey-medium">
                Past Jobs at
                <br />
                {centre?.business_name}
              </div>
            </div>
            <div className="d-flex flex-column gap-5">
              <div className="fs-13 fw-400 text-black">
                {appliedCandidate.last_job_date ?? "-"}
              </div>
              <div className="fs-10 fw-400 text-grey-medium">
                Last Jobs at
                <br />
                {centre?.business_name}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppliedCandidate;
